import Swal from 'sweetalert2';

class SweetToast {
    success(title) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            background: '#d4edda',
            color: '#165931',
            iconColor: '#165931',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            showCloseButton: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'success',
            text: title
        })
    }

    error(title) {
        title = (typeof title === 'object' && title.sqlMessage) ? 'Database error' : title;
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            background: '#f8d7da',
            color: '#762224',
            iconColor: '#762224',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            showCloseButton: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'error',
            text: title
        })
    }

    warning(title) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            background: '#fef3cd',
            color: '#85632a',
            iconColor: '#85632a',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'error',
            text: title
        })
    }

    info(title) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            background: '#762224',
            color: '#164085',
            iconColor: '#164085',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'error',
            text: title
        })
    }

    async confirm(title, text, res) {
        await Swal.fire({
            icon: 'question',
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            confirmButtonColor: '#ea793f',
            iconColor: '#ea793f'
        }).then((result) => {
            if (result.isConfirmed) {
                return res(true);
            } else {
                return res(false);
            }
        })
    }
}

export default new SweetToast;